import { Component } from '@angular/core';
import { MatTab, MatTabGroup, MatTabLabel } from '@angular/material/tabs';
import { TranslatePipe } from '@ngx-translate/core';
import { RequestTableComponent } from './request-table/request-table.component';
import { MatBadge } from '@angular/material/badge';
import { RequestType } from '../../shared/model/request.model';

@Component({
  selector: 'app-requests',
  standalone: true,
  imports: [
    MatTabGroup,
    MatTab,
    TranslatePipe,
    RequestTableComponent,
    MatTabLabel,
    MatBadge,
  ],
  templateUrl: './requests.component.html',
  styleUrl: './requests.component.scss',
})
export class RequestsComponent {
  industriesRequestAmount: number;
  skillRequestsAmount: number;
  mainFocusRequestsAmount: number;
  certificatesRequestAmount: number;
  trainingsRequestsAmount: number;

  protected readonly RequestType = RequestType;
}
